<template lang="pug">
RomatchDialog(:show="show")
  template(v-slot:body)
    p {{ message }}
  template(v-slot:footer)
    .modal-buttons
      RomatchAdminButton.no-button(@click="$emit('no')") {{ noText }}
      RomatchAdminButton.yes-button(@click="$emit('yes')") {{ yesText }}
</template>

<script>
export default {
  name: 'RomatchPromptModal',
  props: {
    show: Boolean,
    message: String,
    yesLabel: String,
    noLabel: String,
  },
  computed: {
    yesText() {
      return this.yesLabel || 'Verwijderen'
    },
    noText() {
      return this.noLabel || 'Annuleren'
    },
  },
}
</script>

<style scoped lang="stylus">
.modal-buttons
  margin-top 2rem
  text-align right

  button
    width 10rem
    margin-left 1rem

  .yes-button
    background #d43

    &:hover
      background #f54

  .no-button
    background transparent
    color #555

    &:hover
      color black
</style>
